import {inject, Injectable} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectMutation, QueryClient} from '@tanstack/angular-query-experimental';
import {
  CreateCustomerProductRequest,
  CustomerProductService,
  UpdateCustomerProductRequest,
} from '../../../../../../api';
import {QueryKey} from '../../../../../constants/query-key';

@Injectable()
export class CustomerProductCommandService {
  private readonly productCustomerService = inject(CustomerProductService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateCustomerProductRequest) =>
      lastValueFrom(this.productCustomerService.createCustomerProduct(request)),
    onSuccess: () => this.invalidateProductCustomerQueries(),
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateCustomerProductRequest }) =>
      lastValueFrom(this.productCustomerService.updateCustomerProduct(request.id, request.body)),
    onSuccess: () => this.invalidateProductCustomerQueries(),
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) => lastValueFrom(this.productCustomerService.deleteCustomerProduct(id)),
    onSuccess: () => this.invalidateProductCustomerQueries(),
  }));


  // Modifier un produit client impacte aussi l'aperçu de facturation, les échéances de l'onglet facturation
  // et les serveurs de licence qui référencent ce produit.
  private invalidateProductCustomerQueries() {
    this.queryClient.invalidateQueries({queryKey: [QueryKey.PRODUCT_CUSTOMERS]});
    this.queryClient.invalidateQueries({queryKey: [QueryKey.PRODUCT_CUSTOMER_HISTORY]});
    this.queryClient.invalidateQueries({queryKey: [QueryKey.INVOICING_PREVIEW]});
    this.queryClient.invalidateQueries({queryKey: [QueryKey.PRODUCT_CUSTOMER_BILLINGS]});
    this.queryClient.invalidateQueries({queryKey: [QueryKey.LICENCE_SERVERS]});
    // Le back resynchronise les factures brouillon (quantité, remise, description, période).
    this.queryClient.invalidateQueries({queryKey: [QueryKey.INVOICES]});
    this.queryClient.invalidateQueries({queryKey: ['invoice']});
    this.queryClient.invalidateQueries({queryKey: ['invoicePdf']});
    this.queryClient.invalidateQueries({queryKey: ['invoiceAccountingOperations']});
  }
}
